import { render, staticRenderFns } from "./connect-wallet.vue?vue&type=template&id=764419e1&scoped=true&"
import script from "./connect-wallet.vue?vue&type=script&lang=ts&"
export * from "./connect-wallet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764419e1",
  null
  
)

export default component.exports